module.exports = __webpack_public_path__ + "static/media/bbot-logo.06e179ac.png";